import { render, staticRenderFns } from "./PrincipalProducts.vue?vue&type=template&id=070cfe2e&scoped=true&"
import script from "./PrincipalProducts.vue?vue&type=script&lang=js&"
export * from "./PrincipalProducts.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalProducts.vue?vue&type=style&index=0&id=070cfe2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070cfe2e",
  null
  
)

export default component.exports